import { useMediaQuery } from './useMediaQuery'

const MOBILE_QUERY = '(max-width: 1023px)'

/**
 * True below the Foundation Docs' documented `1024px` shell breakpoint
 * (`01-layout-system.md` "Responsive breakpoints"). SSR-safe: defaults to
 * `false` (desktop) until the effect runs on the client.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY)
}
